<template>
  <transition-group name="Toast" tag="div" class="Toasts">
    <div v-for="toast in toasts" :key="toast.id" class="Toast" @click="dismissToast(toast.id)">
      <div class="Toast__dot" :class="toast.type === 'error' ? 'bg-red-500' : 'bg-green-500'"></div>
      {{ toast.message }}
    </div>
  </transition-group>
</template>

<script>
import { state, dismissToast, flushPendingToast } from 'utils/toast'

export default {
  computed: {
    toasts() {
      return state.toasts
    }
  },

  mounted() {
    flushPendingToast()
  },

  methods: {
    dismissToast
  }
}
</script>

<style lang="postcss" scoped>
.Toasts {
  @apply fixed inset-x-0 top-0 flex flex-col items-center px-4 pt-20 pointer-events-none;
  /* above vue-last-modal's ModalStack (z-index 1050) so toasts stay visible over modals */
  z-index: 1060;
}

.Toast {
  @apply flex items-center px-6 py-4 mt-3 text-base font-medium text-gray-800 bg-white border rounded-lg shadow-xl cursor-pointer pointer-events-auto;
}

.Toast__dot {
  @apply flex-shrink-0 w-2.5 h-2.5 mr-3 rounded-full;
}

.Toast-enter-active,
.Toast-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.Toast-enter,
.Toast-leave-to {
  opacity: 0;
  transform: translateY(-0.75rem);
}
</style>
